import { Component, OnInit } from '@angular/core';
import { AuthservicesService } from 'src/app/services/authservices.service';
import { environment } from 'src/environments/environment';
import { FormGroup, FormBuilder, Validators, NgForm } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
@Component({
  selector: 'app-email-verfication',
  templateUrl: './email-verfication.component.html',
  styleUrls: ['./email-verfication.component.css']
})
export class EmailVerficationComponent implements OnInit {
  countdown: number = 120; // 2 minutes
timer: any;
canResend: boolean = false;
  form: FormGroup;
  submitted = false;
  isEdit = false;
  num1: any;
  num2: any;
  num3: any;
  num4: any;
  otp: any
  userEmail;
  user: any;
  email: any;
  completeReg: boolean = false
  isSignUp: String = 'false';

  constructor(public fb: FormBuilder, private route: ActivatedRoute, public authService: AuthservicesService, public router: Router) {
  }
  ngOnInit(): void { 
      this.startTimer();
    this.user = JSON.parse(localStorage.getItem('ministry_currentUser'))
    this.userEmail = ''
    if (!this.userEmail) {
      this.userEmail = this.user.email;
    }
    this.form = this.fb.group({
      email: [null, [Validators.required, Validators.email]]
    })
    this.form.setValue({
      email: this.userEmail
    });
    this.route.queryParams.subscribe((params) => {
      console.log(params);
      this.isSignUp = params.signUp;
    });

  }
  get f() { return this.form.controls; }
  startTimer() {
  this.canResend = false;
  this.countdown = 120;

  this.timer = setInterval(() => {
    if (this.countdown > 0) {
      this.countdown--;
    } else {
      this.canResend = true;
      clearInterval(this.timer);
    }
  }, 1000);
}


formatTime() {
  const minutes = Math.floor(this.countdown / 60);
  const seconds = this.countdown % 60;
  return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
}


  public verifyEmail(): void {
    let obj = { varificationCode: parseInt(this.otp) }
    console.log(obj)
    this.authService.verifyEmail(obj).subscribe(
      (response: any) => {
        let data = response['data'];
        console.log(data);
        localStorage.removeItem('user');
        if (this.isSignUp == 'true') {
          this.success("Email Verified. Please continue registration.");
          this.createLog();
          this.router.navigate(["/user-registration/basic-info"]);
        }
        else {
          this.router.navigate(['/profile-management']);
        }
      },
      error => {
        // this.router.navigate(["/profile"]);
        if (error) {
          this.error(error.error.message)
        }
      }
    );

  }
  edit() {
    this.isEdit = !this.isEdit;
    this.form.setValue({
      email: this.userEmail
    });
  }
  public updateEmail(values: Object): void {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }
    // if (this.form.valid) {
    let email = this.form.get('email').value
    let obj = { email: email }
    this.authService.updateEmail(obj).subscribe(
      (response: any) => {
        this.success('Email is updated sucessfully!')
        this.isEdit = false;
        this.getMerchantProfile(this.user.id);
      },
      error => {
        if (error) {
          this.isEdit = false;
          this.error(error.error.message)
        }
      }
    );
    // }
  }


public resendEmail(): void {

  if (!this.canResend) return;

  let obj = { email: this.userEmail };

  this.authService.resendEmail(obj).subscribe(
    (response: any) => {

      this.success('Otp is send successfully!');

      // restart 2-minute timer after successful resend
      this.startTimer();
    },
    error => {
      if (error) {
        this.error(error.error.message);
      }
    }
  );
}
ngOnDestroy() {
  if (this.timer) {
    clearInterval(this.timer);
  }
}
  onOtpChange(otp) {
    this.otp = otp;
    console.log(this.otp)
  }
  getMerchantProfile(id): void {
    this.authService.getCommunityByid(id).subscribe(
      (data: any) => {
        let user = data['data'];
        this.userEmail = user.email;
        if (user.isFirstUpdateDone == true && user.isEmailVarified == true) {
          // this.router.navigate(["/dashboard"]);
          this.success(environment.loginSuccessfullyMessage)
        }
      },
      error => {
        if (error) {
          this.error(error.error.message)
        }
      }
    );

  }
  success(success) {
    this.authService.successMessage(success, 'success')
  }


  error(error) {
    this.authService.successMessage(error, 'error')

  }


  createLog() {
    let obj = {
      userType: "Ministry",
      logType: 'signup',
      userId: this.user?.id
    }
    try { 
      this.authService
      .createLog(obj)
      .subscribe((res: any) => {
        if (res.code == 200) {
          
        }
      });
    }
    catch(error) { 
      console.error(error)
    }
  }
 


}

